/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_Month_SInputs */

const en_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`months`)
};

const de_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat(e)`)
};

const es_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mes(es)`)
};

const fr_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

const it_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mese(i)`)
};

const pt_br2_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mês(es)`)
};

const pl_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`miesiące`)
};

const hu_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hónap`)
};

const ro_admin_plan_discount_form_month_s = /** @type {(inputs: Admin_Plan_Discount_Form_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`luni`)
};

/**
* | output |
* | --- |
* | "months" |
*
* @param {Admin_Plan_Discount_Form_Month_SInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_month_s = /** @type {((inputs?: Admin_Plan_Discount_Form_Month_SInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_Month_SInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_month_s(inputs)
	if (locale === "de") return de_admin_plan_discount_form_month_s(inputs)
	if (locale === "es") return es_admin_plan_discount_form_month_s(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_month_s(inputs)
	if (locale === "it") return it_admin_plan_discount_form_month_s(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_month_s(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_month_s(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_month_s(inputs)
	return ro_admin_plan_discount_form_month_s(inputs)
});
export { admin_plan_discount_form_month_s as "admin.plan_discount_form.month_s" }